import React, { useState, useEffect } from 'react';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';

const Dropdown = ({ currentMode, dropdownData, selectedValue, onChange }) => {
  const handleChange = (event) => {
    const selectedValue = event.itemData.Time; // 'Time' 필드 값 가져오기
    if (onChange) onChange(selectedValue); // 부모 컴포넌트에 선택된 값 전달
  };

  return (
    <div className="w-36 border-1 border-color px-2 py-1 rounded-md"
    style={{ width: '180' }}>
      <DropDownListComponent id="time"
        fields={{ text: 'Time', value: 'Id' }}
        style={{ border: 'none', color: (currentMode === 'Dark') && 'white' }}
        value="1" dataSource={dropdownData}
        popupHeight="220px" popupWidth="240px"
        change={handleChange} // change 이벤트 핸들러 추가
         />
    </div>
  );
};
export default Dropdown;